import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import Button from 'components/Button';
import HelixInfoModal from 'screens/HelixInfoModal';
function HelixInfoButton() {
  var _useTranslation = useTranslation(),
    t = _useTranslation.t;
  var _useState = useState(false),
    _useState2 = _slicedToArray(_useState, 2),
    showInfoModal = _useState2[0],
    setShowInfoModal = _useState2[1];
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Button, {
    variant: "transparent",
    size: "small",
    icon: "info",
    onClick: function onClick() {
      return setShowInfoModal(true);
    }
  }, t('property_helix_info')), showInfoModal && /*#__PURE__*/React.createElement(HelixInfoModal, {
    onClose: function onClose() {
      return setShowInfoModal(false);
    }
  }));
}
export default HelixInfoButton;